import { ErrorReporter } from "@/infrastructure/ErrorReporter";
import { Product, Tracker } from "@studyportals/datalake-event-tracker";
import { injectable } from "inversify";

@injectable()
export class Tracking {
	protected readonly tracker: Tracker;
	protected readonly errorReporter: ErrorReporter;

	public constructor(errorReporter: ErrorReporter) {
		this.tracker = new Tracker(Product.ORGANISATION_SEARCH_PAGE, true, true);
		this.errorReporter = errorReporter;
	}
}
